import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMandatorContext } from "@bn/theming";
import CrownIcon from "@icons/myicons/crown.svg?react";
import { CloseButton } from "@components/Modal/Modal";

type Props = {
  onClose: () => void;
};

export const PremiumModalHeader = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { isAriva, isWso } = useMandatorContext();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2.5}
    >
      <Box display="flex" alignItems="center" gap={3}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={36}
          height={36}
          borderRadius="8px"
          bgcolor="background.success"
          color="primary.main"
        >
          <CrownIcon width="22px" height="22px" />
        </Box>
        <Typography variant="body2" color="textSecondary">
          {t("premium.featuresModal.brand")}
        </Typography>
      </Box>
      <CloseButton onClose={onClose} data-testid="premium-modal-close" />
    </Box>
  );
};
